module.exports = __webpack_public_path__ + "static/media/explainer-poster.62524a6d.png";